import React from "react";
import PlayingArea from "./playing-area";

const Ukulele = (props) => {    
    return (
        <div className="ukulele">
            <PlayingArea/>
        </div>
    );
};

export default Ukulele;